export enum PdfBoxColor {
  grey = 'grey',
  white = 'white',
}
